import { Record } from 'immutable'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { renderNothing, branch, withProps, withHandlers, compose, lifecycle, withState } from 'recompose'
import Fuse from 'fuse.js'
import onClickOutside from 'react-onclickoutside-decorator'

import { makeHasGate } from 'app/modules/gates/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import { properties } from 'app/modules/endUser/attribute/selectors'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import clearbitProperties from 'constants/ClearbitProperties'

import { TokenModalSteps, EditorTokenModal, PropertyNamespaces } from './component'

/* TODO: remove this code once account attributes are pulled in from Account API */
const ExtraProperty = Record({
  name: null,
  displayName: null,
  displayNamespace: PropertyNamespaces.USER,
  requiresABM: false,
})

const extraProperties = [
  new ExtraProperty({ 'name': 'account.name', 'displayName': 'Account Name', 'displayNamespace': PropertyNamespaces.USER, requiresABM: true }),
]
/* END TODO */

export const senderProperties = [
  { name: 'sender.name', displayName: 'Full Name' },
  { name: 'profile.jobTitle', displayName: 'Title' },
  { name: 'org.name', displayName: 'Company Name' },
  { name: 'org.url', displayName: 'Company Website URL' },
  { name: 'org.address', displayName: 'Company Address' },
  { name: 'profile.location', displayName: 'Profile Location' },
  { name: 'sender.email', displayName: 'Email' },
  { name: 'org.twitterLink', displayName: 'Team Twitter Link' },
  { name: 'org.linkedInLink', displayName: 'Team Linkedin Link' },
  { name: 'org.facebookLink', displayName: 'Team Facebook Link' },
  { name: 'profile.phoneNumber', displayName: 'Phone Number' },
//  { name: 'sender.profile_link', displayName: 'Profile Link' }, TODO
  { name: 'profile.twitterHandle', displayName: 'User Twitter' },
  { name: 'profile.instagramHandle', displayName: 'User Instagram' },
  { name: 'profile.linkedInHandle', displayName: 'User Linkedin' },
  { name: 'profile.facebookHandle', displayName: 'User Facebook' },
].map(attr => new ExtraProperty({ displayNamespace: PropertyNamespaces.SENDER, ...attr }))

const tokenStringFromProperty = (property, namespace) => {
  let tokenString = ''
  if (!property.displayNamespace) {
    tokenString = `${namespace}.`
  }
  return `${tokenString}${property.get('name')}`
}

const mapStateToProps = state => ({
  userProperties: properties(state).toArray(),
  hideClearbitTab: PlaybookSelectors.getIsEmailPlaybook(state) || PlaybookSelectors.isSignaturePlaybook(state),
  senderTokensOnly: PlaybookSelectors.isSignaturePlaybook(state),
  hasClearbitEnabled: PlaybookSelectors.hasEnterpriseActions(state),
  hasABM: makeHasGate('ABM')(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAttributes,
      hideTokenModal: PlaybookActions.hideTokenModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      if (!this.props.senderTokensOnly)
        this.props.actions.fetchAttributes()
    },
  }),
  withState('selectedProperty', 'setSelectedProperty', undefined),
  withState('selectedNamespace', 'setSelectedNamespace', undefined),
  withState('selectedTab', 'setSelectedTab', props => props.senderTokensOnly ? PropertyNamespaces.SENDER : PropertyNamespaces.USER),
  withState('modalStep', 'setModalStep', TokenModalSteps.SELECT),
  withState('search', 'setSearch', ''),
  withState('defaultValue', 'setDefaultValue', undefined),
  withHandlers({
    onPropertySelect: props => (name, namespace) => {
      const selectedProperty = extraProperties
        .filter(prop => prop.displayNamespace === PropertyNamespaces.USER)
        .filter(prop => !prop.requiresABM || props.hasABM)
        .concat(props.userProperties)
        .concat(senderProperties)
        .find(property => property.get('name') === name)
      props.setSelectedNamespace(namespace)
      props.setSelectedProperty(selectedProperty)
      props.setModalStep(TokenModalSteps.CONFIRM)
    },
    onDefaultConfirm: props => () => {
      props.setModalStep(TokenModalSteps.SELECT)
      const editor = window.tinymce.activeEditor
      const defaultValue = props.defaultValue ? ` or "${props.defaultValue}"` : ''
      editor.insertContent(
        `<span${props.senderTokensOnly ? '' : ' class="drift-editor-tag mceNonEditable"'}>{{ ${tokenStringFromProperty(props.selectedProperty, props.selectedNamespace)}${defaultValue} }}</span>`
      )
      props.actions.hideTokenModal()
    },
    onClearbitTabClick: props => () => {
      props.hasClearbitEnabled && props.setSelectedTab(PropertyNamespaces.CLEARBIT)
    },
    onUserTabClick: props => () => {
      props.setSelectedTab(PropertyNamespaces.USER)
    },
    hideTokenModal: props => () => {
      // may be duplicative of Cancel handler below... - pk2
      props.setSelectedNamespace(undefined)
      props.setSelectedProperty(undefined)
      props.setDefaultValue(undefined)
      props.setModalStep(TokenModalSteps.SELECT)
      props.actions.hideTokenModal()
    },
    onDefaultCancel: props => () => {
      props.setSelectedNamespace(undefined)
      props.setSelectedProperty(undefined)
      props.setDefaultValue(undefined)
      props.setModalStep(TokenModalSteps.SELECT)
    },
    onSearchChange: props => event => {
      props.setSearch(event.target.value)
    },
    onDefaultChange: props => event => {
      // make sure to escape double quotes
      props.setDefaultValue(event.target.value.replace('"', '\\"'))
    },
    onClickOutside: props => () => {
      // props.setModalOpen(false)
    },
  }),
  withProps(props => {
    const userProperties = extraProperties.filter(prop => prop.displayNamespace === PropertyNamespaces.USER).filter(prop => !prop.requiresABM || props.hasABM).concat(props.userProperties)
    if (!props.search) {
      return {
        clearbitProperties,
        userProperties: userProperties,
        senderProperties,
      }
    } else {
      const fuseConfig = { keys: ['displayName', 'name']}
      const userFuse = new Fuse(userProperties, fuseConfig)
      const clearbitFuse = new Fuse(clearbitProperties, fuseConfig)
      const senderFuse = new Fuse(senderProperties, fuseConfig)
      return {
        userProperties: userFuse.search(props.search),
        clearbitProperties: clearbitFuse.search(props.search),
        senderProperties: senderFuse.search(props.search),
      }
    }
  }),
  withProps(props => ({
    noPropertiesShown: (props.selectedTab === PropertyNamespaces.USER && props.userProperties.length === 0) ||
                       (props.selectedTab === PropertyNamespaces.CLEARBIT && props.clearbitProperties.length === 0) ||
                       (props.selectedTab === PropertyNamespaces.SENDER && props.senderProperties.length === 0)
  })),
  branch(({ noPersonalization }) => noPersonalization, renderNothing),
  onClickOutside
)(EditorTokenModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EditorTokenModal/index.js